import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.73 14.85l-2.52 2.52c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51l-5.27-.61zM18 9h-2.59l5.02-5.02-1.41-1.41L14 7.59V5h-2v6h6z"
}), 'PhoneCallbackSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PhoneCallbackSharp.js
// module id = 5350
// module chunks = 2